import React, { useState } from 'react';
import { ShareLinkBlock } from '../../types';
import {
  LinkIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentIcon,
} from '@heroicons/react/24/outline';
import { toast } from 'sonner';

interface ShareLinkRendererProps {
  block: ShareLinkBlock;
}

export const ShareLinkRenderer: React.FC<ShareLinkRendererProps> = ({ block }) => {
  const { url } = block;
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success('Public tracking link copied to clipboard');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Failed to copy link to clipboard');
    }
  };

  return (
    <div className="my-2.5 w-full bg-blue-50/60 border border-blue-200/80 rounded-xl px-4 py-3 shadow-sm flex items-center justify-between gap-3">
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0 text-blue-700">
          <LinkIcon className="w-4.5 h-4.5" />
        </div>
        <span className="text-sm sm:text-[15px] font-semibold text-gray-900 tracking-wide">
          Public Tracking Link
        </span>
      </div>

      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-white border border-blue-200 text-blue-700 hover:bg-blue-50 shadow-sm transition-colors flex-shrink-0"
      >
        {copied ? (
          <>
            <ClipboardDocumentCheckIcon className="w-4 h-4 text-emerald-600" />
            <span className="text-emerald-700">Copied!</span>
          </>
        ) : (
          <>
            <ClipboardDocumentIcon className="w-4 h-4" />
            <span>Copy Link</span>
          </>
        )}
      </button>
    </div>
  );
};
